import apiClient from '@u/apiClient'
import Promise from 'lodash-es/_Promise'
import MediaController from '@/wayfinder/actions/App/Http/Controllers/Medias/MediaController'
import SearchInShutterStockController from '@/wayfinder/actions/App/Http/Controllers/WebService/SearchInShutterStockController'
import FindSimilarInShutterStockController from '@/wayfinder/actions/App/Http/Controllers/WebService/FindSimilarInShutterStockController'
import SaveShutterStockToGalleyController from '@/wayfinder/actions/App/Http/Controllers/WebService/SaveShutterStockToGalleyController'

export default {
  async fetchMediaById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.getById.get({ media: payload.id }))
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  async updateMediaById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload.data)
      apiClient
        .route(MediaController.update.put({ media: payload.id }), payload.data)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  setMediaFavorityById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.setFavorite.put({ media: payload.id }), payload)
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  getMediaUpscaled({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.upscale.get({ media: payload.id }), {
          responseType: 'blob'
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getMediaColorized({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.colorizer.get({ media: payload.id }), {
          responseType: 'blob'
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getMediaWithoutBackground({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.backgroundRemover.get({ media: payload.id }), {
          responseType: 'blob'
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getMediaWithBackgroundBlur({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.blur.get({ media: payload.id }), {
          responseType: 'blob'
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  changeMediaBackground({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.backgroundChange.get({ media: payload.id }), {
          params: {
            origin: payload.origin,
            ['picture-id']: payload.picture_id
          },
          responseType: 'blob'
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  deleteMediaById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.destroy.delete({ media: payload.media_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  undoDeleteMediaById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.undo.get({ media: payload.media_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  searchInShutterStock: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SearchInShutterStockController.get(), {
          params: {
            term: payload.term
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  findSimilarInShutterStock: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(FindSimilarInShutterStockController.get({ id: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  saveShutterStockToGallery: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SaveShutterStockToGalleyController.get({ id: payload.id }), {
          params: {
            name: payload.name
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  getBackgroundGalleryList: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(MediaController.getBackgroundGallery.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
